<ng-template om-card></ng-template>
